import { render, staticRenderFns } from "./ButtonBackStart.vue?vue&type=template&id=566d44cf&scoped=true&"
import script from "./ButtonBackStart.vue?vue&type=script&lang=js&"
export * from "./ButtonBackStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566d44cf",
  null
  
)

export default component.exports